import { call, put, takeEvery } from "redux-saga/effects"
import { toast } from "react-toastify";
// Crypto Redux States
import {
  ADD_LEAD_APP,
  ADD_LEAD_CALLLOG,
  ADD_LEAD_EMAILLOG,
  ADD_LEAD_NOTE,
  ADD_LEAD_LIST,
  CONVERT_LEAD_INTO_CLIENT,
  CONVERT_LEAD_INTO_CONTACT,
  CREATE_LEAD, GET_LEAD_ALL_ACT, GET_LEAD_APP, GET_LEAD_CALLLOG, GET_LEAD_DETAIL, GET_LEAD_EMAILLOG, GET_LEAD_FOLLOW, GET_LEAD_NOTE,GET_LEAD_LIST, POST_LEAD_FOLLOW, UPDATE_LEAD, UPDATE_LEAD_STAGE_BOARD, UPDATE_LEAD_STATUS_BOARD,
  GET_LEADS,
  DELETE_LEAD,
  UPDATE_LEAD_APP,
  DELETE_LEAD_APP,
  GET_LEAD_PROJECT,
  GET_CAMPAIGN_EMAIL_LIST_LEAD,
  SEND_LEAD_EMAIL,
  SEND_LEAD_SMS
} from "./actionTypes"

import { postLeadData, getLeadDetail, postLeadAPP, getLeadAPP, postLeadNote,postLeadList, getNoteLeadApi,getListLeadApi,postLeadFollow,getFollowLeadApi, getLeadAllAct, updateLeadDataApi, postLeadCalllogNOApi, postLeadCalllogVCApi, postLeadCalllogBNApi, getLeadCalllogApi, postLeadEmaillogERApi, postLeadEmaillogESApi, postLeadEmaillogBBApi, getLeadEmaillogApi, postLeadStageBoardAPI, postLeadStatusBoardAPI, postLeadCovertClientAPI, postLeadCovertContactAPI, getAllLeadUrl, deleteLeadApi, updateLeadAPP, deleteLeadAPP, getLeadProjectAPI, getLeapCampList, postLeadEmailAPI, postLeadSmsAPI, postLeadCalllog } from '../../helpers/backend_helper'

import { addLeadAPPSuccess, createLeadDataFail, createLeadDataSuccess, getAppLeadTabFail, getAppLeadTabSuccess, getLeadDetailFail, getLeadDetailSuccess, addLeadNoteTabSuccess,addLeadListTabSuccess, getNoteLeadTabSuccess,getListLeadTabSuccess, getNoteLeadTabFail,getListLeadTabFail, addLeadFollowTabSuccess, addLeadFollowTabFail, getFollowLeadTabSuccess, getFollowLeadTabFail, getAllActLeadTabSuccess, getAllActLeadTabFail, updateLeadFail, addLeadCallLogSuccess, addLeadCallLogFail, getLeadCallLogSuccess, getLeadCallLogFail, addLeadEmailLogSuccess, addLeadEmailLogFail, getLeadEmailLogSuccess, getLeadEmailLogFail, addLeadLeadStageBoardSuccess, addLeadLeadStageBoardFail, addLeadStatusBoardSuccess, addLeadStatusBoardFail, convertLeadIntoClientSuccess, convertLeadIntoClientFail, convertLeadIntoContactSuccess, convertLeadIntoContactFail, getLeadsSucess, getLeadsFail, deleteLeadSuccess, deleteLeadFail, updateAppLeadTabSuccess, updateAppLeadTabFail, deleteAppLeadTabSuccess, getLeadProjectSuccess, getLeadProjectFail, getCampLeadListSuccess, getCampLeadListFail, SendLeadSmsFail, SendLeadEmailFail, updateLeadSuccess } from "./actions"
import { getCampContactListFail, getCampContactListSuccess } from "store/actions";


// function* submitNewLead({ payload: { lead, callback  } }) {

//   try {
//     toast.loading("Please wait...")
//     const response = yield call(postLeadData,lead)
//     yield put(createLeadDataSuccess(response))
//     if(response.success==true){
//       toast.dismiss();
//       toast.success("New Lead Added");
//       const res = yield call(getAllLeadUrl, lead.agentId)
//       yield put(getLeadsSucess(res))
//     }else{
//       toast.dismiss();
//       toast.warn(response.validationErrors[0]);
//     }
//   }
//   catch (error) {

//     yield put(createLeadDataFail(error))
//   }
// }



function* submitNewLead({ payload: { lead, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");

    const response = yield call(postLeadData, lead);
    yield put(createLeadDataSuccess(response));

    if (response?.success) {
      toast.update(toastId, {
        render: "Saved successfully.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      const res = yield call(getAllLeadUrl, lead.agentId);
      yield put(getLeadsSucess(res));

      if (callback) {
       
        callback(true);
      }
    } else {
      toast.update(toastId, {
        render: response?.validationErrors?.[0] || "Validation failed",
        type: "warning",
        isLoading: false,
        autoClose: 4000,
      });

      if (callback) {
       
        callback(false);
      }
    }
  } catch (error) {
    yield put(createLeadDataFail(error));
    toast.update(toastId, {
      render: "Something went wrong",
      type: "error",
      isLoading: false,
      autoClose: 4000,
    });
    if (callback) {
      callback(false);
    }
  }
}

function* fetchAllLeads({ payload: {brokerId, collectionId} }) {
  try {
    const response = yield call(getAllLeadUrl, brokerId, collectionId)
    yield put(getLeadsSucess(response))
  } catch (error) {
    yield put(getLeadsFail(error))
  }
}

function* onDeleteLead({ payload: lead }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteLeadApi, lead.id)
    yield put(deleteLeadSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully");
    const res = yield call(getAllLeadUrl, lead.agentId)
    yield put(getLeadsSucess(res))

  } catch (error) {
    yield put(deleteLeadFail(error))
  }
}

function* fetchLeadDetail({ leadId }) {
  try {
    const response = yield call(getLeadDetail, leadId)
    yield put(getLeadDetailSuccess(response))
  } catch (error) {
    yield put(getLeadDetailFail(error))
  }
}

function* submitLeadAPP({ payload: { appointment, history } }) {
  try {
    toast.loading("Please wait...")
    //
    const response = yield call(postLeadAPP, {
      appointmentTitle: appointment.appAjenda,
      contactName: appointment.contactName,
      contactPhone: appointment.contactPhone,
      contactEmail: appointment.contactEmail,
      appointmentStartDate: appointment.appADate,
      startTime: appointment.appStat,
      endTime: appointment.appEnd,
      appointmentType: parseInt(appointment.apptype),
      appointmentLocationType: parseInt(appointment.appointmentLocationType),
      appointmentLocation: appointment.appointmentLocation,
      appointmentPriority: parseInt(appointment.appPriority),
      agentId: parseInt(localStorage.getItem("userId")),
      leadId: appointment.leadId,

    })

    yield put(addLeadAPPSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const res = yield call(getLeadAPP, parseInt(localStorage.getItem("userId")), appointment.leadId)
      yield put(getAppLeadTabSuccess(res))
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {
    yield put(getAppLeadTabFail(error.message))
  }
}

function* fetchAppLead({ payload:{ agentId, leadId} }) {
  try {
    const response = yield call(getLeadAPP, agentId, leadId)
    yield put(getAppLeadTabSuccess(response))
  } catch (error) {
    yield put(getAppLeadTabFail(error))
  }
}

function* onUpdateAppLead({ payload: appointment }) {
  try {
    
    toast.loading("Please wait...")
    const response = yield call(updateLeadAPP, appointment)
    toast.dismiss();
    toast.success("Updated successfully.");
    const res = yield call(getLeadAPP, appointment.agentId, appointment.leadId)
    yield put(getAppLeadTabSuccess(res))


  } catch (error) {
    yield put(updateAppLeadTabFail(error))
  }
}

function* onDeleteAppLead({ payload: appointment }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteLeadAPP, appointment.id)
    yield put(deleteAppLeadTabSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully.");
    const res = yield call(getLeadAPP, appointment.agentId, appointment.leadId)
    yield put(getAppLeadTabSuccess(res))

  } catch (error) {
    yield put(deleteContactStatusFail(error))
  }
}

function* addNoteLead({ payload: { notes, history } }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(postLeadNote, {
      remarks: notes.addNote,
      addedBy: parseInt(localStorage.getItem("userId")),
      refId: parseInt(notes.refId),
      addedDate: new Date()

    })
    yield put(addLeadNoteTabSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const agentId = localStorage.getItem('userId');
      const response = yield call(getNoteLeadApi,notes.refId,agentId)
      yield put(getNoteLeadTabSuccess(response))
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(contactapiError('Some Error'))
  }
}

function* addListLead({ payload: { lists, history } }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(postLeadList, {
      createLeadListingLists: lists.data

    })
    yield put(addLeadListTabSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");

    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(contactapiError('Some Error'))
  }
}

function* fetchNoteLead({ leadId }) {
  try {
     const agentId = localStorage.getItem('userId');
    const response = yield call(getNoteLeadApi,leadId, agentId)
    yield put(getNoteLeadTabSuccess(response))
  } catch (error) {
    yield put(getNoteLeadTabFail(error))
  }
}

function* fetchListLead({ leadId }) {
  try {
     const agentId = localStorage.getItem('userId');
    const response = yield call(getListLeadApi,leadId, agentId)
    yield put(getListLeadTabSuccess(response))
  } catch (error) {
    yield put(getListLeadTabFail(error))
  }
}


function* submitFollowLead({ payload: { follows, history } }) {
  try {
    //
    toast.loading("Please wait...")
    const response = yield call(postLeadFollow, {
      message: follows.addNote,
      addedBy: parseInt(localStorage.getItem("userId")),
      refId: parseInt(follows.refId),
      nextFollowupTime: "",
      nextFollowupDate: follows.nextFollowupDate,
      addedDate: new Date(),
      createdFor:parseInt(follows.refId)

    })
    
    yield put(addLeadFollowTabSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const response = yield call(getFollowLeadApi,follows.refId)
      yield put(getFollowLeadTabSuccess(response))
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addLeadFollowTabFail())
  }
}

function* fetchFollowLead({ leadId }) {
  try {
     const agentId = localStorage.getItem('userId');
    const response = yield call(getFollowLeadApi, leadId, agentId)
    yield put(getFollowLeadTabSuccess(response))
  } catch (error) {
    yield put(getFollowLeadTabFail(error))
  }
}

function* fetchAllActLead({ leadId }) {
  try {
    const agentId = localStorage.getItem('userId')
    const response = yield call(getLeadAllAct,leadId,agentId)
    yield put(getAllActLeadTabSuccess(response))
  } catch (error) {
    yield put(getAllActLeadTabFail(error))
  }
}

function* onUpdateLead_old({ payload: lead }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateLeadDataApi, lead)
    
    if(response.success){
      toast.dismiss();
      toast.success("Updated successfully.");
      const res = yield call(getLeadDetail, lead.leadId)
      yield put(getLeadDetailSuccess(response))
    }
    else{
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  


  } catch (error) {
    yield put(updateLeadFail(error))
  }
}

function* onUpdateLead({ payload: { lead, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(updateLeadDataApi, lead);
    
   if (response?.success){
      toast.update(toastId, {
        render: " Updated successfully.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      yield put(updateLeadSuccess(response));
      const res = yield call(getLeadDetail, lead.leadId);
      yield put(getLeadDetailSuccess(res));
      if (callback) {
        
        callback(true);
      }
    } else {
      toast.update(toastId, {
        render: response?.validationErrors?.[0] || "Update failed",
        type: "warning",
        isLoading: false,
        autoClose: 4000,
      });

      if (callback) callback(false);
    }
  } catch (error) {
    yield put(updateLeadFail(error));
    toast.update(toastId, {
      render: "Something went wrong",
      type: "error",
      isLoading: false,
      autoClose: 4000,
    });
    if (callback) callback(false);
  }
}


function* submitLeadCalllog({ payload: { calllog, history } }) {
 toast.loading("Please wait...")
 
  try {
    let eLink = '';
     if (calllog.actionType == 'Call') {
      eLink = postLeadCalllog;
     }
     else if (calllog.actionType == 'No Answer') {
      eLink = postLeadCalllogNOApi;
    } else if (calllog.actionType == 'Left Voicemail') {
      eLink = postLeadCalllogVCApi;
    } else {
      eLink = postLeadCalllogBNApi;
    }

    const response = yield call(eLink, {
      remarks: calllog.callNote,
      addedBy: parseInt(localStorage.getItem("userId")),
      refId: parseInt(calllog.refId),
      addedDate: calllog.addedDate


    })
    yield put(addLeadCallLogSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const agentId = localStorage.getItem('userId');
      const response = yield call(getLeadCalllogApi, calllog.refId, agentId)
    yield put(getLeadCallLogSuccess(response))
    } else {
        toast.dismiss();
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addLeadCallLogFail('Some Error'))
  }
}

function* fetchCalllog({ leadId }) {
  try {
    const agentId = localStorage.getItem('userId');
    const response = yield call(getLeadCalllogApi, leadId, agentId)
    //
    yield put(getLeadCallLogSuccess(response))
  } catch (error) {
    yield put(getLeadCallLogFail(error))
  }
}


function* submitLeadEmailLog({ payload: { emaillog, history } }) {
  //toast.loading("Please wait...")
  try {
    let eLink = '';
    if (emaillog.actionType == 'Email Sent') {
      eLink = postLeadEmaillogESApi;
    } else if (emaillog.actionType == 'Email Received') {
      eLink = postLeadEmaillogERApi;
    } else {
      eLink = postLeadEmaillogBBApi;
    }

    const response = yield call(eLink, {
      remarks: emaillog.remarks,
      addedBy: parseInt(localStorage.getItem("userId")),
      refId: parseInt(emaillog.refId),
      addedDate: emaillog.addedDate


    })
     
    yield put(addLeadEmailLogSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
       const agentId = localStorage.getItem('userId');
      const response = yield call(getLeadEmaillogApi, emaillog.refId, agentId)
      yield put(getLeadEmailLogSuccess(response))
    } else {
      toast.dismiss();
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addLeadEmailLogFail('Some Error'))
  }
}

function* fetchEmailLog({ leadId }) {
  try {
     const agentId = localStorage.getItem('userId');
    const response = yield call(getLeadEmaillogApi, leadId, agentId)
    //
    yield put(getLeadEmailLogSuccess(response))
  } catch (error) {
    yield put(getLeadEmailLogFail(error))
  }
}

function* submitLeadStageBoard({ payload: { leadBoard, history } }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(postLeadStageBoardAPI,leadBoard)
    
    yield put(addLeadLeadStageBoardSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Updated successfully.");

    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addLeadLeadStageBoardFail())
  }
}

function* submitLeadStatusBoard({ payload: { leadBoard, history } }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(postLeadStatusBoardAPI,leadBoard)
    
    yield put(addLeadStatusBoardSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Updated successfully.");

    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addLeadStatusBoardFail())
  }
}


function* submitLeadConvertClient_old({ payload: { lead, history } }) {
  try {
    //
    toast.loading("Please wait...")
    const response = yield call(postLeadCovertClientAPI,lead)
      toast.dismiss();
      toast.success("Lead Converted To Client");
      const res = yield call(getLeadDetail, lead.leadUUid)
      yield put(getLeadDetailSuccess(res))
  }
  catch (error) {

    yield put(convertLeadIntoClientFail())
  }
}
function* submitLeadConvertClient({ payload: { lead, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(postLeadCovertClientAPI, lead);
    if (response?.success) {
      toast.update(toastId, {
        render: "Converted successfully.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      const res = yield call(getLeadDetail, lead.leadUUid);
      yield put(getLeadDetailSuccess(res));
      if (callback) {
        callback(true);
      }
    } else {
      toast.update(toastId, {
        render: response?.validationErrors?.[0] || "Conversion failed",
        type: "warning",
        isLoading: false,
        autoClose: 4000,
      });
      if (callback) {
        callback(false);
      }
    }
  } catch (error) {
    yield put(convertLeadIntoClientFail(error));
    toast.update(toastId, {
      render: "Something went wrong",
      type: "error",
      isLoading: false,
      autoClose: 4000,
    });
    if (callback) {
      callback(false);
    }
  }
}

function* submitLeadConvertContact({ payload: { lead, callback } }) {
  try {
   
    toast.loading("Please wait...")
    const response = yield call(postLeadCovertContactAPI,lead)

      toast.dismiss();
      toast.success("Saved successfully");
      const res = yield call(getLeadDetail, lead.leadUUid)
      yield put(getLeadDetailSuccess(res))
      if (callback) {
        callback(true);
      }
  }
  catch (error) {

    yield put(convertLeadIntoContactFail())
      if (callback) {
        callback(false);
      }
  }
}

function* fetchLeadProject({ leadId }) {
  try {
    const response = yield call(getLeadProjectAPI,leadId)
    yield put(getLeadProjectSuccess(response))
  } catch (error) {
    yield put(getLeadProjectFail(error))
  }
}

function* fetchLeadCampList({ payload:{ agentId, LeadId} }) {
  try {
    const response = yield call(getLeapCampList, agentId, LeadId)
    yield put(getCampLeadListSuccess(response))
  } catch (error) {
    yield put(getCampLeadListFail(error))
  }
}

function* submitLeadEmail({ payload: { email, history } }) {
  try {
   
    toast.loading("Please wait...")
    const response = yield call(postLeadEmailAPI,email)
      toast.dismiss();
      toast.success("Email Sent");
  }
  catch (error) {

    yield put(SendLeadEmailFail())
  }
}

function* submitLeadSMS({ payload: { sms, history } }) {
  try {
   
    toast.loading("Please wait...")
    const response = yield call(postLeadSmsAPI,sms)
      toast.dismiss();
      toast.success("SMS Sent");
  }
  catch (error) {

    yield put(SendLeadSmsFail())
  }
}

function* leadSaga() {
  yield takeEvery(CREATE_LEAD, submitNewLead)
  yield takeEvery(GET_LEADS, fetchAllLeads)
  yield takeEvery(DELETE_LEAD, onDeleteLead)
  yield takeEvery(GET_LEAD_DETAIL, fetchLeadDetail)
  yield takeEvery(UPDATE_LEAD, onUpdateLead)
  yield takeEvery(ADD_LEAD_APP, submitLeadAPP)
  yield takeEvery(GET_LEAD_APP, fetchAppLead)
  yield takeEvery(UPDATE_LEAD_APP, onUpdateAppLead)
  yield takeEvery(DELETE_LEAD_APP, onDeleteAppLead)
  yield takeEvery(ADD_LEAD_NOTE, addNoteLead)
  yield takeEvery(ADD_LEAD_LIST, addListLead)
  yield takeEvery(GET_LEAD_NOTE, fetchNoteLead)
  yield takeEvery(GET_LEAD_LIST, fetchListLead)
  yield takeEvery(POST_LEAD_FOLLOW, submitFollowLead)
  yield takeEvery(GET_LEAD_FOLLOW, fetchFollowLead)
  yield takeEvery(GET_LEAD_ALL_ACT, fetchAllActLead)
  yield takeEvery(ADD_LEAD_CALLLOG, submitLeadCalllog)
  yield takeEvery(GET_LEAD_CALLLOG, fetchCalllog)
  yield takeEvery(ADD_LEAD_EMAILLOG, submitLeadEmailLog)
  yield takeEvery(GET_LEAD_EMAILLOG, fetchEmailLog)
  yield takeEvery(UPDATE_LEAD_STAGE_BOARD,submitLeadStageBoard)
  yield takeEvery(UPDATE_LEAD_STATUS_BOARD,submitLeadStatusBoard)
  yield takeEvery(CONVERT_LEAD_INTO_CLIENT,submitLeadConvertClient)
  yield takeEvery(CONVERT_LEAD_INTO_CONTACT,submitLeadConvertContact)
  yield takeEvery(GET_LEAD_PROJECT, fetchLeadProject)
  yield takeEvery(GET_CAMPAIGN_EMAIL_LIST_LEAD, fetchLeadCampList)
  yield takeEvery(SEND_LEAD_EMAIL, submitLeadEmail)
  yield takeEvery(SEND_LEAD_SMS, submitLeadSMS)
}


export default leadSaga
